(function () {
  'use strict';

  angular.module('ringbaPortal').component('whitelabelSettings', {
    controller: WhitelabelSettings,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/whitelabel-settings/whitelabel-settings.view.html'
  });

  function WhitelabelSettings(
    $filter,
    $q,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $timeout,
    $uibModal,
    accountsService,
    featureFlags,
    whitelabelService,
    toaster,
    utils
  ) {

    const vm = this;

    const status = {
      'CreationUpdate': 'InProgress',
      'Deployed': 'Deployed',
      'Validation': 'PENDING_VALIDATION',
      'Deleting': 'CDN_DELETE_InProgress'
    };

    const whitelabelStep = {
      'INITIAL': 1,
      'PENDING_REQUEST': 1,
      'PENDING_VALIDATION': 1,
      'ISSUED': 2,
      'InProgress': 3,
      'CDN_NOT_CREATED': 3,
      'Deployed': 4
    };

    const disableCNameChangeonSteps = {
      'CDN_NOT_CREATED': 'WL_DISABLE_CNAME_CHANGE',
      'ISSUED': 'WL_DISABLE_CNAME_CHANGE_ISSUED',
      'InProgress': 'WL_DISABLE_CNAME_CHANGE_CREATE_OR_UPDATE_PROGRESS',
      'CDN_DELETE_InProgress': 'WL_DISABLE_CNAME_CHANGE_DELETING'
    };

    const cNameChangeOnStepMessage = {
      'PENDING_REQUEST': 'WL_PENDING_REQUEST_OR_VALIDATION_CNAME_CHANGE',
      'PENDING_VALIDATION': 'WL_PENDING_REQUEST_OR_VALIDATION_CNAME_CHANGE'
    };

    //TODO: Review failed error messages
    const errorSteps = {
      'EXPIRED': 'CNAME_EXPIRED_ERROR',
      'FAILED': 'CNAME_FAILED_ERROR',
      'INACTIVE': 'CNAME_INACTIVE_ERROR',
      'REVOKED': 'CNAME_REVOKE_ERROR',
      'VALIDATION_TIMED_OUT': 'CNAME_VALIDATION_TIMED_OUT_ERROR',
      'CDN_FAILED': 'CNAME_CDN_FAILED_ERROR'
    };

    vm.whiteLabelSettings = {};
    vm.originUrl = 'https://' + whitelabelService.getBaseFriendlyUrl();

    vm.$onInit = onInit;
    vm.validateDuplicacy = validateDuplicacy;
    vm.showThemeEditor = showThemeEditor;
    vm.updateFriendlyNameSettings = updateFriendlyNameSettings;
    vm.updateCNameSettings = updateCNameSettings;
    vm.deleteCNameSettings = deleteCNameSettings;
    vm.toggleCnameForm = toggleCnameForm;
    vm.checkConfirmationInput = checkConfirmationInput;
    vm.submitCname = submitCname;
    vm.cancelModal = cancelModal;

    function onInit() {
      if (!featureFlags.isOn('whiteLabel')) {
        $state.go('dashboard.main');
      }
      vm.loading = true;
      vm.hideCnameForm = !vm.cName;
      _loadSettings();
      if ($stateParams.cname) {
        $timeout(function() {
          vm.hideCnameForm = false;
          utils.scrollToElementId('cname');
        }, 0);
      }
    }

    function validateDuplicacy(newFriendlyName) {
      if (newFriendlyName) {
        whitelabelService.validateFriendlyName(accountsService.currentAccountId, newFriendlyName).then(function (response){
          if (vm.whitelabelFriendlyNameSettingsForm && vm.whitelabelFriendlyNameSettingsForm.friendlyName) {
            vm.whitelabelFriendlyNameSettingsForm.friendlyName.$setValidity('duplicate', response.data.valid || vm.friendlyName === vm.whiteLabelSettings.friendlyName);
          }
        });
      }
    }

    function showThemeEditor() {
      $rootScope.$emit('showThemeEditor');
    }

    function updateFriendlyNameSettings() {
      return whitelabelService.saveFriendlyName(accountsService.currentAccountId, vm.whiteLabelSettings.friendlyName).then(function(response) {
        vm.friendlyName = response.data.updatedFriendlyName;
        toaster.pop('success', $filter('translate')('WHITELABEL_SAVE_FRIENDLY_NAME_SUCCESS'));
      }).catch(utils.errorHandler);
    }

    function updateCNameSettings(force) {
      if (force) {
        return _saveCName();
      }

      if (vm.whiteLabelSettings.cnameSettings && cNameChangeOnStepMessage[vm.whiteLabelSettings.cnameSettings.state] && _toShowConfirmationMessage(vm.whiteLabelSettings)) {
        vm.cNameChangeConfirmationMessage = _toShowConfirmationMessage(vm.whiteLabelSettings);
        _showCNameChangeConfirmation();
      } else if (vm.whiteLabelSettings.cnameSettings && vm.whiteLabelSettings.cnameSettings.state === status['Deployed'] && _toShowConfirmationMessage(vm.whiteLabelSettings)) {
        _showChangeDoubleConfirmation();
      } else {
        _showCnameConfirmationModal();
      }
      return $q.when({});
    }

    function submitCname() {
      if (vm.confirmationInput === vm.cName) {
        return _saveCName();
      }
      return $q.when({});
    }

    function deleteCNameSettings(force) {
      if (!force) {
        _showDeleteConfirmation();
        return $q.when({});
      } else if (vm.confirmationInput === vm.whiteLabelSettings.cnameSettings.cname) {
        return whitelabelService.deleteCName(accountsService.currentAccountId).then(function() {
          toaster.pop('success', $filter('translate')('WHITELABEL_DELETE_CNAME_SUCCESS'));
          cancelModal();
          vm.whiteLabelSettings.cnameSettings.state = status['Deleting'];
          _setCNameUIStep();
        }).catch(utils.errorHandler);
      }
      return $q.when({});
    }

    function _saveCName() {
      if (vm.cName && vm.cName.length > 0) {
        return whitelabelService.saveCName(accountsService.currentAccountId, vm.cName).then(function(response) {
          vm.showCnameSaveMessage = true;
          vm.cnameStep = 1;
          vm.whiteLabelSettings.cnameSettings = response.data.updatedCNameSettings;
          _setCNameUIStep();
          toaster.pop('success', $filter('translate')('WHITELABEL_SAVE_CNAME_SUCCESS'));
          cancelModal();
        }).catch(utils.errorHandler);
      }
      toaster.pop('error', $filter('translate')('WHITELABEL_SAVE_CNAME_INVALID_CNAME'));
      cancelModal();
      return $q.when({});
    }

    function _showDeleteConfirmation() {
      vm.confirmationInput = undefined;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-settings/cname-delete-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function _showChangeDoubleConfirmation() {
      vm.confirmationInput = undefined;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-settings/cname-change-double-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function _showCnameConfirmationModal() {
      vm.confirmationInput = undefined;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-settings/cname-save-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function checkConfirmationInput() {
      if (vm.confirmationInput === vm.whiteLabelSettings.cnameSettings.cname) {
        return _saveCName();
      }
      return $q.when({});
    }

    function toggleCnameForm() {
      vm.hideCnameForm = !vm.hideCnameForm;
    }

    function cancelModal() {
      vm.confirmationInput = undefined;
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function _showCNameChangeConfirmation() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-settings/cname-change-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function _toShowConfirmationMessage(whiteLabelSettings) {
      if (whiteLabelSettings.cnameSettings && whiteLabelSettings.cnameSettings.cname !== vm.cName) {
        return (cNameChangeOnStepMessage[whiteLabelSettings.cnameSettings.state] && $filter('translate')(cNameChangeOnStepMessage[whiteLabelSettings.cnameSettings.state]))
        || true;
      }
      return false;
    }

    function _showCNameError(step) {
      vm.cNameErrorMessage = errorSteps[step];
    }

    function _loadSettings() {
      whitelabelService.getWhitelabelSettings(accountsService.currentAccountId)
        .then(function (response) {
          vm.originUrl = response.data.whiteLabelSettings.baseFriendlyUrl;
          vm.whiteLabelSettings = response.data.whiteLabelSettings;
          vm.friendlyName = vm.whiteLabelSettings && vm.whiteLabelSettings.friendlyName;
          _setCNameUIStep();
        })
        .catch(function() {
          vm.whiteLabelSettings = {};
        });
    }

    function _setCNameUIStep() {
      if (vm.whiteLabelSettings.cnameSettings) {
        vm.cName = vm.whiteLabelSettings.cnameSettings.cname;
        vm.disableCNameInput = (disableCNameChangeonSteps[vm.whiteLabelSettings.cnameSettings.state] && $filter('translate')(disableCNameChangeonSteps[vm.whiteLabelSettings.cnameSettings.state]))
        || undefined;
        if (errorSteps[vm.whiteLabelSettings.cnameSettings.state]) {
          _showCNameError(vm.whiteLabelSettings.cnameSettings.state);
        } else {
          vm.cnameStep = whitelabelStep[vm.whiteLabelSettings.cnameSettings.state] || 0;
        }
      } else {
        vm.disableCNameInput = false;
        vm.cnameStep = 0;
        vm.cNameErrorMessage = undefined;
      }

    }


  }
})();
